import { render } from "./ProductNotifyAvailable.vue?vue&type=template&id=5c010e12"
import script from "./ProductNotifyAvailable.vue?vue&type=script&lang=js"
export * from "./ProductNotifyAvailable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__